var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{ref:"iframe",staticStyle:{"border":"none","position":"absolute","top":"0","left":"0","width":"100%","height":"100%"},style:(`${_vm.calcHeight}`),attrs:{"src":_vm.source,"allow":"accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture","allowfullscreen":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }